import React from "react";


export default function FieldSelectField_InlineValueNotEmpty(props:any) {

    const selectedField = props.field.fields.get(props.value)
    const iconClasses = Classes('ui5-ico-15 m-r-8', selectedField.icon)

    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable no-wrap" onClick={props.onClick}>
                <div className={iconClasses} />
                {selectedField?.label}
            </div>

            {props.children}
        </React.Fragment>
    )
}
